import React from 'react';

const PricingToggle = ({ isAnnual, onToggle }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px', marginBottom: '64px' }}>
      <span style={{
        fontFamily: 'var(--font-heading)',
        fontSize: '14px',
        fontWeight: isAnnual ? 400 : 700,
        color: isAnnual ? 'var(--color-muted-foreground)' : 'var(--color-foreground)',
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        transition: 'all 200ms ease',
      }}>Månedlig</span>

      {/* Toggle switch */}
      <button
        onClick={onToggle}
        aria-label="Bytt faktureringsperiode"
        style={{
          position: 'relative',
          width: '56px',
          height: '28px',
          background: isAnnual ? '#FF5722' : 'rgba(224,228,232,0.15)',
          border: `2px solid ${isAnnual ? '#FF5722' : 'rgba(224,228,232,0.2)'}`,
          borderRadius: '2px',
          cursor: 'pointer',
          transition: 'all 250ms ease',
          padding: 0,
          outline: 'none',
        }}
      >
        {/* Beveled knob */}
        <div style={{
          position: 'absolute',
          top: '3px',
          left: isAnnual ? 'calc(100% - 22px - 3px)' : '3px',
          width: '18px',
          height: '18px',
          background: '#FFFFFF',
          borderRadius: '1px',
          transition: 'left 250ms ease',
          boxShadow: '0 1px 4px rgba(0,0,0,0.3)',
        }} />
      </button>

      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <span style={{
          fontFamily: 'var(--font-heading)',
          fontSize: '14px',
          fontWeight: isAnnual ? 700 : 400,
          color: isAnnual ? 'var(--color-foreground)' : 'var(--color-muted-foreground)',
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          transition: 'all 200ms ease',
        }}>Årlig</span>
        {/* Savings badge */}
        <div style={{
          background: isAnnual ? 'rgba(255,87,34,0.15)' : 'rgba(255,255,255,0.04)',
          border: `1px solid ${isAnnual ? 'rgba(255,87,34,0.4)' : 'rgba(224,228,232,0.1)'}`,
          borderRadius: '2px',
          padding: '3px 10px',
          transition: 'all 250ms ease',
        }}>
          <span style={{
            fontFamily: 'var(--font-heading)',
            fontSize: '11px',
            fontWeight: 700,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: isAnnual ? '#FF5722' : 'var(--color-muted-foreground)',
            transition: 'color 250ms ease',
          }}>Spar 20%</span>
        </div>
      </div>
    </div>
  );
};

export default PricingToggle;
